import React from 'react';
import styled from "styled-components";


const Hero = () => {
    return (
        <Wrapper>
            <Content>
                <h2>IDEA: KONKURS na plakat: 550 urodziny Mikołaja Kopernika</h2>
                <p>Czy słyszeliście coś, kiedyś o Mikołaju Koperniku? Zapraszamy Was do udziału w konkursie na plakat
                    upamiętniający 550-te urodziny Mikołaja Kopernika!</p>

                <p>19 lutego 2023 roku przypada 550. rocznica urodzin wybitnego uczonego i astronoma Mikołaja Kopernika,
                    który nie tylko dokonał jednego z najważniejszych odkryć w historii, ale również zapoczątkował
                    rewolucję
                    naukową, która zmieniła postrzeganie świata. Jest to postać niezwykle istotna zarówno dla historii
                    Polski, jak i całego świata. Jako człowiek renesansu Mikołaj Kopernik zajmował się wieloma
                    dziedzinami
                    nauki; astronomią, astrologią, matematyką, ekonomią, kartografią i filologią.
                    Mikołaj Kopernik, pol., Nicolaus Copernicus[a], łac., Nikolaus Kopernikus, niem., urodził się 19
                    lutego
                    1473 w Toruniu.
                    Konkurs odbywa się w ramach Światowego Kongresu Kopernikańskiego, z okazji ustanowienia uchwałą
                    Senatu
                    RP roku 2023 Rokiem Mikołaja Kopernika.
                    Kongres organizują wspólnie: Uniwersytet Mikołaja Kopernika w Toruniu, Uniwersytet Jagielloński w
                    Krakowie, Uniwersytet Warmińsko-Mazurski w Olsztynie oraz Polska Akademia Nauk.
                </p>
                <h2>CEL KONKURSU:</h2>
                <p> Wyłonienie najciekawszych plakatów, kreacji graficznych na temat przewodni konkursu; 550. urodziny
                    Mikołaja Kopernika.
                </p>
                <h2>NAGRODY:</h2>
                <p>Spośród nadesłanych zgłoszeń międzynarodowe Jury wyłoni laureatów:</p>
                <p> Grand Prix - 3000 PLN, </p>
                <p>1 Nagroda- 2000 PLN, </p>
                <p> 2 Nagroda- 1500 PLN </p>
                <p>3 Nagroda- 1000 PLN,</p>
                <p>Wyróżnienie- 500 PLN</p>

                <p>oraz</p>
                <p>maksymalnie 100 finalistów, których plakaty zostaną zaprezentowane na wystawach pokonkursowych w
                    Centrum
                    Ekspozycyjnym Stara Kotłownia w Olsztynie, oraz we Fromborku i Toruniu. Spośród plakatów
                    zakwalifikowanych do finału 20 najlepszych zostanie wystawionych w przestrzeni miejskiej Olsztyna,
                    Fromborka oraz na Gali finałowej w Olsztynie podczas Konferencji Kopernikańskiej.
                </p>


                <h2>TERMINY:</h2>
                <p>Ogłoszenie konkursu: 18 luty 2023</p>
                <p>Otwarcie rejestracji prac: 15 marca 2023</p>
                <p>Data przesłania projektów: 30 kwietnia 2023 godz. 23.59</p>
                <p> Lista osób zakwalifikowanych: 15 maja 2023</p>
                <p>Data przesłania plików Hi-Res: 30 maja 2023</p>
                <p>Ogłoszenie finalistów i zwycięzców: czerwiec 2023</p>
                <p>Wystawy pokonkursowe: czerwiec 2023 — grudzień 2023</p>

                <h2> JAK ZGŁOSIĆ PLAKAT</h2>
                <p> 1. W konkursie mogą brać udział studenci i absolwenci, którzy ukończyli studia w ciągu ostatnich 5
                    lat. </p>
                <p>2. Każdy uczestnik może zgłosić maksymalnie trzy różne plakaty.</p>
                <p> 3. Zgłoszenia można przesyłać wyłącznie online, wypełniając formularz zgłoszeniowy:
                    http://rokkopernika.uwm.edu.pl/konkurs/</p>
                <p>4. Specyfika: format zgłoszeń: podgląd plakatu 7 x 10 cm, 300 dpi, RGB, jpg trzy różne plakaty.</p>

                <h3>TERMIN NADSYŁANIA ZGŁOSZEŃ: 30.04.2023 (23:59 GMT)</h3>

                <h2>SKŁADANIE PRAC KONKURSOWYCH:</h2>
                <p>1. Prace prześlij przez formularz znajdujący się na stronie konkursu: format: 10 × 7 cm (orientacja
                    pionowa), 300 dpi, RGB, jpg (maksymalnie 5 MB) do dnia 30 kwietnia 2023 r.</p>
                <p>2. Plik pracy nazwij swoim imieniem i nazwiskiem oraz numerem np. adam_kowalsky_1.jpg. Na pracy
                    zabrania
                    się
                    podawania imienia i nazwiska w jakimkolwiek miejscu na pracy.</p>
                <p>3. Ostateczny termin nadsyłania prac konkursowych (wglądówek): 30 kwietnia 2023 r.</p>
                <p>4. Ostateczny termin nadsyłania prac wybranych do finału konkursu, pliki do druku Hi-Res; 100 x 70
                    cm,
                    200
                    dpi, CMYK, jpg, (maksymalnie 30 MB): 30 maja 2023.</p>
            </Content>
        </Wrapper>
    )
}

export default Hero


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12% 10% 0 10%;
  position: relative;

  h1 {
    font-family: Lato;
    color: #E44432;
    font-weight: 800;
    margin-top: 10px;
    padding: 10px;
    border-radius: 50px;
  }

  h3 {
    font-family: Lato;
    color: white;
    background-color: #E44432;
    font-size: 20px;
    font-weight: 600;
    padding: 20px;
    border-radius: 50px;
  }

  h2 {
    font-family: Lato;
    color: #E44432;
    font-weight: 800;
    margin-top: 10px;
    padding: 0px 10px;
    border-radius: 50px;
  }

  p {
    margin: 0;
    font-family: Lato;
    margin-bottom: 12px;
    padding: 0 10px;
    font-size: 14px;
    line-height: 1.5;
  }
`


const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 700px;

  @media (max-width: 768px) {
    width: 100vw;
    box-sizing: border-box;
    padding: 20px;
  }
`



